// extracted by mini-css-extract-plugin
export default {"add-remove-points":"styles_add-remove-points__naD5c","buttons":"styles_buttons__anpnC","selected":"styles_selected__558H1","warning":"styles_warning__3sQYX"};